/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon32Regular = forwardRef('ArrowFigureACircleRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M9 16a1 1 0 0 1 1-1h10.41l-3.308-3.308a1 1 0 1 1 1.414-1.414l3.6 3.6a2.99 2.99 0 0 1 .877 2.002 1.012 1.012 0 0 1 0 .24 2.99 2.99 0 0 1-.876 2.001l-3.601 3.601a1 1 0 0 1-1.414-1.414L20.409 17H10a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16ZM16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5Z" })));
});
